// 23.01.19 - Used for error handling.
export const API_ERROR_MESSAGE: string = "Error while getting data";
export const NETWORK_ERROR_MESSAGE: string = "Please check network connection";
export const CASE_GET_ERROR_MESSAGE: string = "Error while getting case data";
export const CASE_GET_UPDATE_MESSAGE: string = "Error while updating case data";
export const FILE_DOWNLOAD_ERROR: string = 'Error while file download';
export const FILE_UPLOAD_ERROR: string = 'Error while file upload';
export const DATA_SAVE_SUCCESS: string = "Data saved succesfully";
export const DATA_UPDATE_SUCCESS: string = "Data updated succesfully";